import React from 'react';
import styled from '@xstyled/styled-components';
import { Button } from '~/ui/buttons/Button';
import MicrophoneIcon from '~/assets/icons/microphone.svg';
import { useVoiceInput } from '~/training/sequence/templates/items/chatBot/hooks/useVoiceInput';

const VoiceInputButton = styled(Button)`
  padding: 6px;

  @keyframes pulseAnimation {
    0% {
      opacity: 1;
      background-color: var(--color-accent-dk);
    }
    50% {
      opacity: 0.8;
      background-color: blue;
    }
    100% {
      opacity: 1;
      background-color: var(--color-accent-dk);
    }
  }

  &.recording {
    animation: pulseAnimation 2s infinite;
  }
`;

interface VoiceInputProps {
  onTranscript: (transcript: string) => void;
  disabled?: boolean;
  title?: string;
}

export const VoiceInput: React.FC<VoiceInputProps> = ({
  onTranscript,
  disabled = false,
  title = 'Voice input'
}) => {
  const { isSupported, isRecording, startRecording } = useVoiceInput({
    onTranscript,
    disabled
  });

  if (!isSupported) {
    return null;
  }

  return (
    <VoiceInputButton
      onClick={startRecording}
      disabled={disabled}
      className={isRecording ? 'recording' : ''}
      title={title}
    >
      <MicrophoneIcon />
    </VoiceInputButton>
  );
};
